import { Component, computed, input, model } from '@angular/core';
import { IconName, IconNames } from '@icon/assets';
import { UiButtonComponent, UIIconComponent } from '@design-system';
import { guid } from '@tools';

@Component({
	selector: 'app-accordion',
	imports: [UiButtonComponent, UIIconComponent],
	templateUrl: './accordion.component.html',
	host: {
		class: 'block w-full'
	}
})
export class AccordionComponent {
	readonly label = input.required<string>();
	/**
	 * Optional glyph shown before the label. The settings page names each of its
	 * three sections with one; elsewhere the label stands alone.
	 */
	readonly iconName = input<IconNames | ''>('');
	readonly expanded = model(false);
	readonly expandedMaxHeightClass = input('max-h-60');
	readonly titleClass = input('');
	readonly containerClass = input('');
	protected readonly IconName = IconName;

	private readonly id = guid();
	readonly headerId = `app-accordion-header-${this.id}`;
	readonly contentId = `app-accordion-content-${this.id}`;

	readonly panelClasses = computed(() => {
		const maxHeightClass = this.expanded() ? this.expandedMaxHeightClass() : 'max-h-0';
		return `overflow-hidden transition-[max-height] duration-400 ease-in-out ${maxHeightClass}`;
	});

	toggle(): void {
		this.expanded.update(value => !value);
	}
}
